import { render, staticRenderFns } from "./ContractDetailsSummary.vue?vue&type=template&id=15b3605a"
import script from "./ContractDetailsSummary.vue?vue&type=script&lang=js"
export * from "./ContractDetailsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports